// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/v1/address.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/address.proto.
 */
export const file_common_v1_address: GenFile = /*@__PURE__*/
  fileDesc("Chdjb21tb24vdjEvYWRkcmVzcy5wcm90bxIJY29tbW9uLnYxIocBCgdBZGRyZXNzEgwKBG5hbWUYASABKAkSDQoFbGluZTEYAiABKAkSEgoFbGluZTIYAyABKAlIAIgBARIMCgRjaXR5GAQgASgJEg8KB2NvdW50cnkYBSABKAkSFQoIemlwX2NvZGUYBiABKAlIAYgBAUIICgZfbGluZTJCCwoJX3ppcF9jb2RlIq4BCg5CaWxsaW5nQWRkcmVzcxIMCgRuYW1lGAEgASgJEg0KBWxpbmUxGAIgASgJEhIKBWxpbmUyGAMgASgJSACIAQESDAoEY2l0eRgEIAEoCRIPCgdjb3VudHJ5GAUgASgJEhUKCHppcF9jb2RlGAYgASgJSAGIAQESEwoGdGF4X2lkGAcgASgJSAKIAQFCCAoGX2xpbmUyQgsKCV96aXBfY29kZUIJCgdfdGF4X2lkQk5aTGdpdGh1Yi5jb20vZW1tZW1zL3N1cGVyLWNhcnQvYXBwcy9zcnYtd29ya2VyL3V0aWxzL21vZGVscy9jb21tb24vdjE7Y29tbW9udjFiBnByb3RvMw");

/**
 * @generated from message common.v1.Address
 */
export type Address = Message<"common.v1.Address"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string line1 = 2;
   */
  line1: string;

  /**
   * @generated from field: optional string line2 = 3;
   */
  line2?: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string country = 5;
   */
  country: string;

  /**
   * @generated from field: optional string zip_code = 6;
   */
  zipCode?: string;
};

/**
 * Describes the message common.v1.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema: GenMessage<Address> = /*@__PURE__*/
  messageDesc(file_common_v1_address, 0);

/**
 * @generated from message common.v1.BillingAddress
 */
export type BillingAddress = Message<"common.v1.BillingAddress"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string line1 = 2;
   */
  line1: string;

  /**
   * @generated from field: optional string line2 = 3;
   */
  line2?: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string country = 5;
   */
  country: string;

  /**
   * @generated from field: optional string zip_code = 6;
   */
  zipCode?: string;

  /**
   * @generated from field: optional string tax_id = 7;
   */
  taxId?: string;
};

/**
 * Describes the message common.v1.BillingAddress.
 * Use `create(BillingAddressSchema)` to create a new message.
 */
export const BillingAddressSchema: GenMessage<BillingAddress> = /*@__PURE__*/
  messageDesc(file_common_v1_address, 1);

